const formatEnum = (string: string) => {
	string = string.replace('_', ' ');
	return string.substring(0, 1).toUpperCase() + string.substring(1);
};

export default formatEnum;
